<template>
	<div
		:style="{'background-image': (image)?'url(' + image + ')':null}" 
		@dragstart="$emit('dragstart', $event)" 
		@dragend="$emit('dragend', $event)" 
		@drag="$emit('drag', $event)" 
		@touchstart="$emit('touchstart', $event)" 
		@touchend="$emit('touchend', $event)" 
		@touchmove="$emit('touchmove', $event)"
		class="lazy-image lazy-background"
		@load="loading = false"
		@error="loading = false"
	>
		<slot></slot>
		<span class="svg" v-if="loading" :style="{width: imgWidth + 'px', height: imgHeight + 'px'}">
			<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" class="svg-loader">
				<circle cx="50" cy="50" r="45" />
			</svg>
		</span>
	</div>
</template>

<script>
	export default {
		props: ['src'],
		data() {
			return {
				intersected: false,
				observer: null,
				loading: false,
				imgWidth: 0,
				imgHeight: 0
			};
		},
		computed: {
			image() {
				if(!this.src) {
					return null;
				}
				let pieces = this.src.split('?');
				return (this.intersected && !this.loading)?(pieces[0] + this.$store.state.webp + ((pieces[1])?'?'+pieces[1]:'')):null;
			}
		},
		watch: {
			intersected() {
				if(this.intersected && this.src) {
					this.loading = true;
					let pieces = this.src.split('?');
					let img = document.createElement('img');
					img.src = pieces[0] + this.$store.state.webp + ((pieces[1])?'?'+pieces[1]:'');
					let self = this;
					img.addEventListener('load', (event) => {
						self.loading = false;
						img = null;
					});
					img.addEventListener('error', (event) => {
						self.loading = false;
						img = null;
					});
				}
			}
		},
		mounted() {
			const bounds = this.$el.getBoundingClientRect();
			this.imgWidth = bounds.width;
			this.imgHeight = bounds.height;
			if(this.imgHeight > this.imgWidth) {
				this.imgHeight = this.imgWidth;
			} else {
				this.imgWidth = this.imgHeight;
			}

			let self = this;
			self.observer = new IntersectionObserver((entries) => {
				const image = entries[0];
				if(image.isIntersecting) {
					self.intersected = true;
					self.observer.disconnect();
				}
			});
			self.observer.observe(self.$el);
		},
		destroyed() {
			this.observer.disconnect();
		}
	}
</script>